import { createFileRoute, Navigate } from "@tanstack/react-router";
import { UppdragStatus } from "types/uppdrag.type";

export const Route = createFileRoute("/_authenticated/app/")({
  component: AppIndexRoute,
});

function AppIndexRoute() {
  return (
    <Navigate
      to={"/app/uppdrag"}
      search={{
        statuses: [UppdragStatus.Scheduled, UppdragStatus.Started],
      }}
    />
  );
}
